import { Modal, Box, IconButton, CloseIcon } from 'src/components';
import { Profile } from 'src/pages/profile'

export default function DesktopProfileModal({displayLogin, setDisplayLogin}) {

    return (
        <Modal 
            open={displayLogin}
            onClose={() => setDisplayLogin(false)}
            sx={{zIndex: 10000 }}>
                    <Box sx={{
                        bgcolor: '#fff',
                        width: '260px', 
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        paddingTop: '10px',
                        paddingBottom: '15px',
                        borderRadius: 2
                    }}>
                        <IconButton
                            onClick={() => setDisplayLogin(false)}
                            size="small"
                            sx={{
                                position: 'absolute',
                                top: 2,
                                right: 2
                            }}>
                            <CloseIcon fontSize="small" />
                        </IconButton>

                        <Profile />

                    </Box>
        </Modal>
    );
}
